export default {
  No: 1,
  HRUsers: 2,
  BusinessUsers: 3,
  HRAndBusinessUsers: 4
}